import { Pipe, PipeTransform } from '@angular/core';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';

@Pipe({
  name: 'formatrut'
})
export class FormatrutPipe implements PipeTransform {

  constructor(private rutFormatter: RutFormatterService) {}

  transform(run: number): string {
    const dv = this.rutFormatter.getDv(run);
    return this.rutFormatter.format(run + '-' + dv);
  }

}
